import { render, staticRenderFns } from "./SendCoinsModal.vue?vue&type=template&id=47ed6bdb&scoped=true&"
import script from "./SendCoinsModal.vue?vue&type=script&lang=ts&"
export * from "./SendCoinsModal.vue?vue&type=script&lang=ts&"
import style0 from "./SendCoinsModal.vue?vue&type=style&index=0&id=47ed6bdb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed6bdb",
  null
  
)

export default component.exports